import ModalDialog from './modal-dialog.js';

class SearchDialog extends ModalDialog {
    /**
     * @type {import('./course-search.js').default}
     */
    get search() {
        return this.querySelector('.combo-box');
    }

    /**
     * @param {MouseEvent & {target: Element}} event
     * @override
     */
    onClick(event) {
        const example = event.target.closest('.text-button');
        if (example) {
            event.preventDefault();
            this.search.fill(example.textContent.toLowerCase());
        }
        super.onClick(event);
    }
}

customElements.define('search-dialog', SearchDialog);
export default SearchDialog;
